import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  NotificationPreferencesState,
  UpdateNotificationPreference,
} from "./models/notificationModels";
import notificationPreferencesApi from "./api/notificationPreferencesApi";

export const fetchNotificationPreferences = createAsyncThunk(
  "notificationPreferencesSlice/fetchPreferences",
  async () => {
    return notificationPreferencesApi.getPreferences();
  }
);

export const updateNotificationPreferences = createAsyncThunk(
  "notificationPreferencesSlice/updatePreferences",
  async (preferences: UpdateNotificationPreference[]) => {
    await notificationPreferencesApi.updatePreferences(preferences);
    return preferences;
  }
);

const initialState: NotificationPreferencesState = {
  preferences: [],
  loading: false,
  actionLoading: false,
  error: undefined,
};

const notificationPreferencesSlice = createSlice({
  name: "notificationPreferencesSlice",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchPreferences
      .addCase(fetchNotificationPreferences.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchNotificationPreferences.fulfilled, (state, action) => {
        state.loading = false;
        state.preferences = action.payload;
      })
      .addCase(fetchNotificationPreferences.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // updatePreferences
      .addCase(updateNotificationPreferences.pending, (state) => {
        state.actionLoading = true;
        state.error = undefined;
      })
      .addCase(updateNotificationPreferences.fulfilled, (state, action) => {
        state.actionLoading = false;
        // Update local preferences with the saved values
        action.payload.forEach((updated) => {
          const existing = state.preferences.find(
            (p) => p.eventType === updated.eventType
          );
          if (existing) {
            existing.isInAppEnabled = updated.isInAppEnabled;
            existing.isEmailEnabled = updated.isEmailEnabled;
          }
        });
      })
      .addCase(updateNotificationPreferences.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearError } = notificationPreferencesSlice.actions;

export default notificationPreferencesSlice.reducer;
